import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class SiteTypesService {

  constructor(private http: HttpClient) { }

  // Get all site types with no pagination
  public getAllSiteTypesNoPagination() {
    return this.http.get(environment.apiUrl + 'api/ext-site-type?size=10000000&page=0')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Create new site type
  public createSiteType(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-site-type/create', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Edit site type
  public editSiteType(obj) {
    return this.http.put(environment.apiUrl + 'api/ext-site-type', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Handle Responses
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }


  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }

}
